// react components
import React from 'react'

// pages
import {
    ImageHelper825,
    LinkHelper825,
} from 'pages'

// props
type RatioHelper825Props = {
    alt: string | undefined
    borderRadius?: string
    dominant_color: string | undefined
    edit: boolean
    fixedRatioPercentage?: string
    href?: string
    imageContain?: boolean
    onClick?: () => void
    src: string | undefined
    to: string | undefined
}

// main
export const RatioHelper825: React.FC<RatioHelper825Props> = React.memo(({
    alt,
    borderRadius,
    dominant_color,
    edit,
    fixedRatioPercentage,
    href,
    imageContain,
    onClick,
    src,
    to,
}) => {

    function onLinkClick() {
        if (onClick) onClick()
    }

    return (
        <LinkHelper825
            className={`ratio-helper-825${(to || onClick) ? ' link' : ' no-link'}${imageContain ? ' contain' : ''}`}
            edit={edit}
            href={href}
            onClick={() => onLinkClick()}
            to={to}
        >
            <div
                className='rhw-image-wrap'
                style={{
                    borderRadius: borderRadius,
                    paddingBottom: fixedRatioPercentage,
                }}
            >
                <ImageHelper825
                    alt={alt || 'What The Web'}
                    className='rhw-image'
                    dominant_color={dominant_color}
                    src={src}
                />
            </div>
        </LinkHelper825>
    )
})
